import React from 'react'
import Link from 'gatsby-link'
import iconArrow from '../../images/svg/arrow-right.svg'
import './style.sass'

const Menu = ({ onLinkClick }) => (
  <div className="Menu">
    <div className="wrap">
      <div className="Menu__Row">
        <div className="Menu__Column Menu__Column--left">
          <Link to="/" onClick={onLinkClick}>
            <h1 className="text-bold">
              Milan and Ticino
              <br />
              (1796-1848).
              <br />
              Shaping
              <br />
              the Spatiality
              <br />
              of a European <br />
              Capital
            </h1>
          </Link>
        </div>
        <div className="Menu__Column Menu__Column--right">
          <Link to="/" className="Menu__Link" onClick={onLinkClick}>
            Home Page
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link to="/progetto" className="Menu__Link" onClick={onLinkClick}>
            Il Progetto
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link
            to="/sottoprogetti"
            className="Menu__Link"
            onClick={onLinkClick}
          >
            Sotto-progetti
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link to="/agenda" className="Menu__Link" onClick={onLinkClick}>
            Agenda
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link
            to="/pubblicazioni"
            className="Menu__Link"
            onClick={onLinkClick}
          >
            Pubblicazioni
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link
            to="/gruppo-di-ricerca"
            className="Menu__Link"
            onClick={onLinkClick}
          >
            Gruppo di Ricerca
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
          <Link to="/contatti" className="Menu__Link" onClick={onLinkClick}>
            Contatti
            <img src={iconArrow} alt="Arrow icon" />
          </Link>
        </div>
      </div>
    </div>
  </div>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/menu/index.js